/*
 *   File : custom-tooltip.js
 *   Author : https://evoqins.com
 *   Description : tooltip component
 *   Integrations : NA
 *   Version : 1.0.0
*/

// packages
import React from 'react';
import { Tooltip } from 'react-tooltip';

// component
import Icon from '../Icon/icon';

// style
import style from '../../Style/Component/tooltip.module.scss';

const CustomTooltip = (props) => {
    return (
        <div className={`${style.e_tooltip} `}>
            {props.icon !== false &&
                <Icon icon='info'
                    size={props.size ? props.size : '0.75rem'}
                    color={props.color}
                    data-tooltip-id={props.id}
                    className='cursor-pointer d-flex  e-outline-none'
                    data-tooltip-content={props.content} />
            }

            <Tooltip id={props.id}
                place={props.place || 'bottom-start'}
                offset={props.offset}
                className={style.e_custom_tooltip}
                style={{
                    width: props.width || 'auto',
                    maxWidth: props.maxWidth,
                    padding: props.padding,
                }}
            />
        </div>
    );
}

export default CustomTooltip;